<template>
  <div class="w-full sm:w-1/3 xl:w-1/5">
    <notifications position="top center"></notifications>

    <a @click="isOpen = !isOpen" href="#">
      <button
          type="button"
          class="w-full mx-auto inline text-center text-sm uppercase mt-3 px-6 py-3 border border-transparent font-medium shadow-sm text-white bg-blue-500 hover:bg-blue-700 focus:outline-none  focus:ring-offset-2 focus:ring-blue-500"
      ><i class="fas fa-plus mr-2"></i> Add Pledge
      </button>
    </a>

    <transition
        enter-class="transition ease-out duration-100 transform"
        enter-active-class="opacity-0"
        enter-to-class="opacity-100"
        leave-class="transition ease-in duration-200 transform"
        leave-active-class="opacity-100"
        leave-to-class="opacity-0"
    >
      <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

          <div class="fixed inset-0 transition-opacity" aria-hidden="true">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6"
              role="dialog" aria-modal="true" aria-labelledby="modal-headline"
          >
            <div class="sm:flex sm:items-start">
              <div class="text-center sm:mt-0 sm:text-left w-full">
                <div class="flex justify-between items-center pb-3">
                  <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                    Add Pledge
                  </h3>
                  <div class="modal-close cursor-pointer z-50">
                    <svg
                        @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg"
                        width="18" height="18" viewBox="0 0 18 18"
                    >
                      <path
                          d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                      ></path>
                    </svg>
                  </div>
                </div>

                <div class="my-3">
                  <div>
                    <label for="first_name" class="block text-sm font-medium text-gray-700">First Name</label>
                    <div class="mt-1">
                      <input
                          class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          :class="{' border-red-500': errors.includes('first_name') === true, 'border-gray-160': errors.includes('first_name') === false }"
                          name="first_name"
                          id="first_name"
                          aria-label="first_name"
                          v-model="form.first_name"
                      >
                    </div>
                  </div>
                </div>

                <div class="my-3">
                  <div>
                    <label for="last_name" class="block text-sm font-medium text-gray-700">Last Name</label>
                    <div class="mt-1">
                      <input
                          class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          :class="{' border-red-500': errors.includes('last_name') === true, 'border-gray-160': errors.includes('last_name') === false }"
                          name="last_name"
                          id="last_name"
                          aria-label="last_name"
                          v-model="form.last_name"
                      >
                    </div>
                  </div>
                </div>

                <div class="my-3">
                  <div>
                    <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
                    <div class="mt-1">

                      <input
                          class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          :class="{' border-red-500': errors.includes('email') === true, 'border-gray-160': errors.includes('email') === false }"
                          name="email"
                          id="email"
                          aria-label="email"
                          v-model="form.email"
                      >
                    </div>
                  </div>
                </div>

                <div class="my-3">
                  <div>
                    <label for="phone" class="block text-sm font-medium text-gray-700">Phone</label>
                    <div class="mt-1">

                      <input
                          class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          :class="{' border-red-500': errors.includes('phone') === true, 'border-gray-160': errors.includes('phone') === false }"
                          name="phone"
                          id="phone"
                          aria-label="Phone"
                          v-model="form.phone"
                      >
                    </div>
                  </div>
                </div>

                <div class="my-3">
                  <div class="my-1">
                    <label class="block text-sm font-medium text-gray-700">Amount</label>
                  </div>

                  <div class="mt-1 flex rounded-md shadow-sm">
                          <span
                              class="inline-flex items-center px-3 border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                          >
                              $
                          </span>
                    <input
                        class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        :class="{' border-red-500': errors.includes('amount') === true, 'border-gray-160': errors.includes('amount') === false }"
                        name="amount"
                        id="amount_input"
                        aria-label="Amount (to the nearest dollar)"
                        v-model="form.amount"
                    >
                  </div>

                </div>


                <div class="my-3">
                  <div class="my-1">
                    <label class="block text-sm font-medium text-gray-700">Not to Exceed Amount</label>
                  </div>

                  <div class="mt-1 flex rounded-md shadow-sm">
                          <span
                              class="inline-flex items-center px-3 border border-r-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                          >
                              $
                          </span>
                    <input
                        class="appearance-none block w-full px-3 py-2 border shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        :class="{' border-red-500': errors.includes('amount_limit') === true, 'border-gray-160': errors.includes('amount_limit') === false }"
                        name="amount_limit"
                        id="amount_limit"
                        aria-label="Amount (to the nearest dollar)"
                        v-model="form.amount_limit"
                    >
                  </div>

                </div>


              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                  @click="addPledge" type="button"
                  class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Add
              </button>
              <button
                  @click="isOpen = false" type="button"
                  class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>

export default {
  name: 'AddPledgeButton',
  props: {
    pledgeDrive: null,
    pledgeDriveEvents: null,
  },
  data() {
    return {
      isOpen: false,
      deposit_name: null,
      form: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        amount: null,
        amount_limit: null,
        _token: null,
        pledge_drive_id: this.pledgeDrive.id,
        campaign_id: this.pledgeDrive.campaign_id,
      },
      errors: []
    }
  },
  methods: {
    setOpenToFalse() {
      this.isOpen = false;
    },
    addPledge() {

      if (!this.form.first_name) {
        this.errors.push('firstName')
      }
      if (!this.form.last_name) {
        this.errors.push('last_name')
      }
      if (!this.form.email || !this.validEmail()) {
        this.errors.push('email')
      }
      if (!this.form.phone) {
        this.errors.push('phone')
      }
      if ( !this.form.amount) {
        this.errors.push('amount')
      }

      if (this.errors.length > 0) {
        this.$notify({
          text: 'Please fix the validation errors',
          type: 'error',
        })
        this.isSaving = false
        return
      }


      let token = document.head.querySelector('meta[name="csrf-token"]');
      this.form._token = token.content;

      axios.post('/campaign/' + this.pledgeDrive.campaign_id + '/pledge-drive/' + this.pledgeDrive.id + '/add-pledge', this.form)
          .then(response => {
            this.$notify({
              text: 'Pledge has been added.',
              type: 'success',
            })

            window.location.reload();
          })




    },
    validEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.form.email);
    },

    validMoney(money) {
      // https://stackoverflow.com/questions/2227370/currency-validation
      var regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/
      return regex.test(money);
    },
  },

}
</script>

<style scoped>

</style>
